export const API_PATH_ApiTrafficStudyPostClap = '/services/traffic-studies/apiTrafficStudyPostClap';
